export enum LoadingActions {
  UPDATE_SHOW = 'loading/UPDATE_SHOW',
}

export type LoadingType = {
  show: boolean;
};

export const initialState: LoadingType = {
  show: false,
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function reducer(state = initialState, action: any) {
  switch (action.type) {
    case LoadingActions.UPDATE_SHOW: {
      return {
        ...state,
        ...action.show,
      };
    }
    default:
      return state;
  }
}
